module.exports = require("./lib/api/node.js");



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/index.js
// module id = 6
// module chunks = 0